/*
 * @Author: Han
 * @Date: 2022-01-13 13:32:28
 * @LastEditors: Han
 * @LastEditTime: 2022-01-18 10:22:37
 * @FilePath: \console\console\src\http\api.js
 */
import * as login from './moudules/login'
import * as home from './moudules/home'
import * as menu from './moudules/menu'
import * as role from './moudules/role'
import * as accountManagement from './moudules/accountManagement'
import * as book from './moudules/book'
import * as experienceManagement from './moudules/experienceManagement'
import * as banner from './moudules/banner'
import * as user from './moudules/user'
import * as experienceNote from './moudules/experienceNote'
import * as messageManagement from './moudules/messageManagement'


/* 
 * 将所有接口统一起来便于维护
 * 如果项目很大可以将 url 独立成文件，接口分成不同的模块
 */
// 默认全部导出
export default {
  login,
  home,
  menu,
  role,
  accountManagement,
  book,
  experienceManagement,
  banner,
  user,
  experienceNote,
  messageManagement
}



// WEBPACK FOOTER //
// ./src/http/api.js